/**
 * @generated SignedSource<<9dc76a0ea05c88ee38cdd4d09db1b634>>
 * @relayHash 8dd5b06fa5bc2d9ff4de6b64c4af3db1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5814336fa93e71dd8b822b81d36d3d15b1166a15ff61ecfa37f53dea0958da24

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JsmProjectMenuWrapper_SidebarQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type JsmProjectMenuWrapper_SidebarQuery$data = {
  readonly jira_projectLevelSidebarMenuCustomization: {
    readonly __typename: "JiraProjectLevelSidebarMenuCustomization";
    readonly hiddenMenuItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly itemId: string;
        } | null;
      } | null> | null;
    } | null;
    readonly renamedMenuItems: {
      readonly " $fragmentSpreads": FragmentRefs<"JsmProjectMenuContent_renamedMenuItems">;
    } | null;
  } | {
    readonly __typename: "QueryError";
    readonly __typename: "QueryError";
    readonly message: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type JsmProjectMenuWrapper_SidebarQuery = {
  response: JsmProjectMenuWrapper_SidebarQuery$data;
  variables: JsmProjectMenuWrapper_SidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "projectKey",
    "variableName": "projectKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "itemId"
},
v5 = {
  "concreteType": "JiraProjectLevelSidebarMenuItemConnection",
  "kind": "LinkedField",
  "name": "hiddenMenuItems",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraProjectLevelSidebarMenuItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraProjectLevelSidebarMenuItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/)
          ]
        }
      ]
    }
  ]
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JsmProjectMenuWrapper_SidebarQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "jira_projectLevelSidebarMenuCustomization",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              {
                "concreteType": "JiraProjectLevelSidebarRenamedMenuItemConnection",
                "kind": "LinkedField",
                "name": "renamedMenuItems",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "JsmProjectMenuContent_renamedMenuItems"
                  }
                ]
              }
            ],
            "type": "JiraProjectLevelSidebarMenuCustomization"
          },
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "JsmProjectMenuWrapper_SidebarQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "jira_projectLevelSidebarMenuCustomization",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              {
                "concreteType": "JiraProjectLevelSidebarRenamedMenuItemConnection",
                "kind": "LinkedField",
                "name": "renamedMenuItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectLevelSidebarRenamedMenuItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraProjectLevelSidebarRenamedMenuItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "renamedMenuItemName"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ],
            "type": "JiraProjectLevelSidebarMenuCustomization"
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "5814336fa93e71dd8b822b81d36d3d15b1166a15ff61ecfa37f53dea0958da24",
    "metadata": {},
    "name": "JsmProjectMenuWrapper_SidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3edea9079a7d67e96cfc0889fb336b98";

export default node;
